import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { Route, Router, Switch, Link } from "wouter";
import store from "@/store/store.js";
import { CartProvider } from "@/providers/CartProvider.jsx";
import Shop from '@/components/Shop.jsx';
import SalesProductPage from '@/components/SalesProductPage.jsx';
import CheckoutPage from '@/components/CheckoutPage.jsx';
import ConfirmationPage from '@/components/ConfirmationPage.jsx';
import ScrollTopOnNavigation from "@/components/ScrollTopOnNavigation.jsx";

const routes = {
  '/': {
    component: Shop
  },
  '/product/:id': {
    component: SalesProductPage
  },
  '/checkout': {
    component: CheckoutPage
  },
  '/confirmation': {
    component: ConfirmationPage
  }
};

const ShopApp = () => (
  <div id="app-bounds">
    <Provider store={store}>
      <CartProvider>
        <div className="shop-app">
          <Switch>
            <Router base='/shop'>
              <ScrollTopOnNavigation />
              <div id="shop-header" className="w-100 d-flex mb-4">
                <div className="header-left">
                  <Link to='/'>
                    <h2>Shop Miracles</h2>
                  </Link>
                </div>
                <div className="header-right">
                  <Link to='/checkout'>
                    <span className="fa fa-shopping-cart"></span>
                  </Link>
                </div>
              </div>
              {Object.entries(routes).map(([path, config]) => {
                const Component = config.component;
                return (
                  <Route path={path} key={path}>
                    <Component />
                  </Route>
                );
              })}
            </Router>
          </Switch>
        </div>
      </CartProvider>
    </Provider>
  </div>
);

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(document.getElementById('shop-app'));
  root.render(<ShopApp />);
});
